module.exports = __webpack_public_path__ + "img/background-customer.da206ea2.svg";